export enum ERoles {
  user = "USER", //DBMS role(int)==1
  admin = "ADMIN", //DBMS role(int)==0
}
